import { PathRegexNameMap, RouteNameMap } from '~/constants/routes'

export function getRouteTitleByPath(path: string) {
  const RegexList = Object.keys(PathRegexNameMap)
  const matchedRegExp = RegexList.find((regExp) => RegExp(regExp).test(path))

  if (!matchedRegExp) {
    return undefined
  }

  const handlerOrTitle =
    PathRegexNameMap[matchedRegExp as keyof typeof PathRegexNameMap]
  if (typeof handlerOrTitle !== 'function') {
    return handlerOrTitle
  }
  const matches = path.match(matchedRegExp) || []
  const innerMatches = matches.slice(1)
  const preparedMatches = innerMatches.map(
    (item) => RouteNameMap[item as keyof typeof RouteNameMap] || item,
  )
  return handlerOrTitle(preparedMatches)
}

export const usePersistClickedItemOnURL =
  (paramName: string = 'initialItem') =>
  (index: number | undefined) => {
    if (index !== undefined) {
      const url = new URL(window.location.href)
      url.searchParams.set(paramName, index.toString())
      window.history.replaceState(
        { ...window.history.state, as: url.href, url: url.href },
        '',
        url.href,
      )
    }
  }
